import React, { useEffect } from "react";

import { trackEvent } from "@src/multiCustodian/services/tracking";
import Text from "@src/sharedComponents/Typography/Text";

const HouseholdDocuments = (): JSX.Element => {
  useEffect(() => {
    trackEvent({
      name: "Advisor Open Household Documents Tab",
    });
  }, []);

  return <Text>HouseholdDocuments</Text>;
};

export default HouseholdDocuments;
